const RECOVERABLE_ERROR = 'RECOVERABLE_ERROR';
const NONRECOVERABLE_ERROR = 'NONRECOVERABLE_ERROR';
const CANNOT_EXECUTE_QUERY = 'CANNOT_EXECUTE_QUERY';

export { CANNOT_EXECUTE_QUERY, NONRECOVERABLE_ERROR, RECOVERABLE_ERROR };
//# sourceMappingURL=generic-query-errors.js.map
